













































































import _ from 'lodash';
import { computed, defineComponent, nextTick, ref, getCurrentInstance } from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';
import smh, { SMH } from '@/renderer/scripts/smh';
import tips from '@/renderer/scripts/utils/tips';
export default defineComponent({
  props: {
    show: {
      required: true,
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const validateStatus = ref('default');
    const sensitiveWord = ref<Array<string>>([]);
    const headerTitle = ref(i18n_t('添加敏感词'));
    const addType = ref('add');
    const usedNum = ref(0);
    const successWords = ref<Array<string>>([]);
    const showPopupConfirm = ref(false);
    const popupTips = ref('');
    let tagInput = '';
    const methods = {
      popupConfirm() {
        showPopupConfirm.value = false;
        const words = methods.handlerWords(tagInput);
        let flag = false;
        if (words.length > 20) {
          tips.error(i18n_t('单个敏感词限制20个字符，单次添加词数最多20条'));
          flag = true;
        } else if (words.length > 0) {
          for (let i = 0; i < words.length; i++) {
            if (words[i].length > 20) {
              tips.error(i18n_t('单个敏感词限制20个字符，单次添加词数最多20条'));
              flag = true;
              break;
            }
          }
        }
        if (!flag) {
          sensitiveWord.value.push(...words);
          methods.addSensitiveWord(true);
        }
      },
      async addSensitiveWord(isConfirm = false) {
        const words = methods.handlerWords(tagInput);
        if (!isConfirm && words.length > 0 && sensitiveWord.value.length > 0) {
          showPopupConfirm.value = true;
          const str = words.length > 2 ? words.slice(0, 2).join(',') : words.join(',');
          popupTips.value = i18n_t('敏感词“{str}”{slot1}未添加为敏感词，是否确认添加？', {
            str,
            slot1:
              words.length > 2
                ? i18n_t('等{slot1}个', {
                    slot1: words.length,
                  })
                : '',
          });
          return;
        }
        try {
          const { data } = await smh.userAPI.createSensitiveWord({
            words: sensitiveWord.value,
          });
          if (data.failedItems.length === sensitiveWord.value.length) {
            reporter.report('sensitive_manage', {
              add_status: 'false',
            });
            addType.value = 'fail';
            headerTitle.value = i18n_t('添加失败');
            return;
          }
          if (data.successItems.length > 0) {
            let sensitiveWord = '';
            data.successItems.forEach((item: { word: string }) => {
              sensitiveWord += `${item.word};`;
            });
            reporter.report('sensitive_manage', {
              add_status: 'true',
              add_name: sensitiveWord,
            });
            addType.value = 'success';
            headerTitle.value = i18n_t('添加成功');
            data.successItems.forEach((item: { word: string }) => {
              successWords.value.push(item.word);
            });
            usedNum.value = data.failedItems.length;
          }
        } catch (err: MsgError) {
          if (err?.code === 'CreateSensitiveWordFailed') {
            addType.value = 'fail';
            headerTitle.value = i18n_t('添加失败');
          } else {
            tips.error(err);
          }
        }
      },
      handlerWords(words: string): string[] {
        const len = words.length;
        let result = [''];
        let temp = words;
        const lastChatNotAvailable = temp.charAt(len - 1) === ';' || temp.charAt(len - 1) === '；';
        if (lastChatNotAvailable) {
          temp = words.slice(0, -1);
        }
        if (temp.indexOf(';') !== -1) {
          result = words.split(';');
          for (let i = 0; i < result.length; i++) {
            if (result[i].indexOf('；') !== -1) {
              result.push(...result[i].split('；'));
              result.splice(result.indexOf(result[i]), 1);
            }
          }
        } else if (temp.indexOf('；') !== -1) {
          result = temp.split('；');
        } else if (temp.indexOf('；') === -1 && temp.indexOf(';') === -1) {
          result = [temp];
        }
        for (let i = 0; i < result.length; i++) {
          result[i] = result[i].trim();
        }
        result = result.filter((str: string) => !!str);
        return result;
      },
      validateShow() {
        tips.error(i18n_t('单个敏感词限制20个字符，单次添加词数最多20条'));
        validateStatus.value = 'error';
      },
      modifyData(
        val: any,
        context: {
          inputValue: any;
        },
      ) {
        const words = methods.handlerWords(context.inputValue);
        sensitiveWord.value.push(...words);
        sensitiveWord.value.splice(sensitiveWord.value.indexOf(context.inputValue), 1);
        if (words.length > 20) {
          methods.validateShow();
        } else if (words.length > 0) {
          for (let i = 0; i < words.length; i++) {
            if (words[i].length > 20) {
              methods.validateShow();
            }
          }
        }
      },
      changeData(val: Array<string>) {
        nextTick(() => {
          const flag = sensitiveWord.value.every((item: string) => {
            return item.length <= 20;
          });
          if (val.length > 20) {
            methods.validateShow();
            return;
          }

          // 判断是否有重复的标签
          const isRepeat = new Set(sensitiveWord.value).size !== sensitiveWord.value.length;
          methods.markRepeatTag(sensitiveWord.value);
          if (validateStatus.value !== 'error' && isRepeat) {
            tips.error(i18n_t('输入敏感词中有重复项'));
            validateStatus.value = 'error';
            return;
          }
          validateStatus.value = flag && !isRepeat ? 'default' : 'error';
        });
      },
      onInputChange(val: string) {
        tagInput = val;
      },
      resetDialog(isClose = true) {
        if (isClose) innerShow.value = false;
        addType.value = 'add';
        validateStatus.value = 'default';
        headerTitle.value = i18n_t('添加敏感词');
        sensitiveWord.value = [];
        tagInput = '';
        usedNum.value = 0;
        successWords.value = [];
      },
      startCheck() {
        methods.resetDialog();
        context.emit('start');
      },
      backAddWord(type: string) {
        sensitiveWord.value = type === 'fail' ? sensitiveWord.value : [];
        methods.resetDialog(false);
      },
      // 将重复的标签标红
      markRepeatTag(words: string[]) {
        // 获取数组中重复的几个
        const repeatWords = [
          ...new Set(words.filter((item: string) => words.indexOf(item) !== words.lastIndexOf(item))),
        ];
        nextTick(() => {
          setTimeout(() => {
            const tags = document.querySelectorAll('.sensitive-box .t-tag');
            for (let i = 0; i < tags.length; i++) {
              const text = tags[i].children[0].innerHTML;
              if (repeatWords.indexOf(text) !== -1) {
                tags[i].classList.add('repeat-tag');
              } else {
                tags[i].classList.remove('repeat-tag');
              }
            }
          });
        });
      },
    };
    return {
      innerShow,
      validateStatus,
      sensitiveWord,
      headerTitle,
      addType,
      usedNum,
      successWords,
      showPopupConfirm,
      popupTips,
      ...methods,
    };
  },
});
